/* global axios */
import ApiClient from '../ApiClient';

// T-220: o agente responde por e-mail dentro do mesmo atendimento.
//
// Vai como multipart porque leva anexo. O backend cria a mensagem NA MESMA conversa, então não
// há nada a criar aqui: a resposta chega pela atualização normal da conversa.
class RespostaEmailAPI extends ApiClient {
  constructor() {
    super('fandata/conversations', { accountScoped: true });
  }

  enviar(conversationId, { texto, anexos = [] }) {
    const dados = new FormData();
    dados.append('texto', texto);
    anexos.forEach(arquivo => dados.append('anexos[]', arquivo));

    return axios.post(`${this.url}/${conversationId}/resposta_email`, dados, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }
}

export default new RespostaEmailAPI();
